function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.94382 15.9375H11.3242C11.6341 15.9375 11.8876 15.6844 11.8876 15.375V12C11.8876 11.6906 11.6341 11.4375 11.3242 11.4375H7.94382C7.63395 11.4375 7.38042 11.6906 7.38042 12V15.375C7.38042 15.6844 7.63395 15.9375 7.94382 15.9375ZM18.0851 5.25H16.3949V3.5625C16.3949 3.25312 16.1413 3 15.8315 3H14.7047C14.3948 3 14.1413 3.25312 14.1413 3.5625V5.25H9.63403V3.5625C9.63403 3.25312 9.3805 3 9.07063 3H7.94382C7.63395 3 7.38042 3.25312 7.38042 3.5625V5.25H5.69021C4.75707 5.25 4 6.00586 4 6.9375V19.3125C4 20.2441 4.75707 21 5.69021 21H18.0851C19.0182 21 19.7753 20.2441 19.7753 19.3125V6.9375C19.7753 6.00586 19.0182 5.25 18.0851 5.25ZM18.0851 19.1016C18.0851 19.2176 17.99 19.3125 17.8738 19.3125H5.90148C5.78528 19.3125 5.69021 19.2176 5.69021 19.1016V8.625H18.0851V19.1016Z",
  fill: "#424240"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Calendar.356e11c7.svg";
export { ForwardRef as ReactComponent };